import React, {useState} from "react";
import {Box, Button, InputAdornment, Modal, TextField, Typography} from "@mui/material";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import ImageRenderer from "../../utils/ImageRenderer";
import MoneyRenderer from "../../utils/MoneyRenderer";
import UnitOfMeasureTitleRenderer from "../../utils/UnitOfMeasureTitleRenderer";
import UnitOfMeasureRenderer from "../../utils/UnitOfMeasureRenderer";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined';

export function AddToCartModal({open, setOpen, handleAddToCart, product}) {
    const [quantity, setQuantity] = useState('');

    const handleQuantityChange = (value) => {
        setQuantity(value);
    };

    const aQuantityWasEntered = quantity !== '' && quantity !== null && quantity !== undefined;

    async function addToCart(quantity) {
        await handleAddToCart(quantity)
        setOpen(false)
    }

    const articleInformation = {
        CantidadUnidades: product.Articulo.CantidadUnidades,
        UnidadDeItems: product.Articulo.UnidadDeItems,
        PrecioUnidad: product.PrecioUnidad,
        PrecioArticulo: product.PrecioArticulo,
        NombreFantasia: product.Articulo.Producto.NombreFantasia,
        Image: product.Articulo.Producto.Archivos[0].Url,
    }

    return (
        <>
            <input type="hidden" name="aniadir-articulo-id"/>
            <Modal open={open} onClose={() => setOpen(false)} aria-labelledby="add-cart-modal-title">
                <Box sx={{
                    ...style,
                    width: '80%',
                    maxWidth: '800px',
                    borderRadius: '7px',
                    maxHeight: "90vh",
                    overflowY: "auto",
                    padding: "20px",
                    backgroundColor: "#fff",
                    "@media (max-width: 768px)": {
                        width: "95%",
                        maxWidth: "100%",
                        padding: "15px",
                    },
                }}>
                    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    }}>
                        <p className="general-title title-info-product">Añadir al carrito</p>
                        <Button
                            onClick={() => setOpen(false)}
                            style={{
                                position: 'absolute',
                                top: '25px',
                                right: '25px',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '5px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px'
                            }}
                        >
                            <p className="general-title title-info-product" style={{ margin: 0, fontSize: '12px'}}>cerrar</p>
                            <FontAwesomeIcon icon={faTimesCircle} className="general-title title-info-product"/>
                        </Button>
                    </Box>
                    <Box className="modal-body">
                        <Box className="container-fluid">
                            <Box className="row">
                                <Box className="col-xs-12 col-sm-6 col-sm-push-6 clearpadding">
                                    <Box
                                        className="img-add-cart"
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'right',
                                        }}
                                    >
                                        <img
                                            src={ImageRenderer(articleInformation.Image)}
                                            alt="Foto de Categoría"
                                            className="img-responsive"
                                            style={{
                                                width: 'auto',
                                                height: 'auto',
                                                objectFit: 'contain',
                                                marginLeft: '40px',
                                                marginTop: '40px'
                                            }}
                                        />
                                    </Box>

                                </Box>
                                <Box className="col-xs-12 col-sm-6 col-sm-pull-6 clearpadding">
                                    <Typography variant="h5" sx={{ marginBottom: '10px', color: '#ffffff' }}>
                                        <div className="h4 title-product show" style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}> {articleInformation.NombreFantasia} </div>
                                    </Typography>
                                    <Box className="visible-xs">
                                        <Box className="text-center">

                                        </Box>
                                    </Box>
                                    <table className="table" style={{ width: '100%', border: '' , borderCollapse: 'collapse' }}>
                                        <tbody style={{ border: '' }}>
                                        <tr style={{ borderBottom: '1px solid #ddd' }}>
                                            <td style={{ width: '10%', textAlign: 'left', paddingLeft: '0px' }}>
                                                <span
                                                    className="material-symbols-outlined"
                                                    style={{
                                                        color: '#5e5d5d',
                                                        fontSize: "1.2em",
                                                        marginRight: "5px",
                                                        position: "relative",
                                                        top: "4px"
                                                    }}
                                                >
                                                    <Inventory2OutlinedIcon/>
                                                </span>
                                            </td>
                                            <td style={{ width: '60%', textAlign: 'left', paddingLeft: '10px' }}>Cada Unidad</td>
                                            <td className="costo-product" style={{ textAlign: 'right', paddingRight: '0px', fontSize: '18px', color: '#c1a17d' }}>
                                                <span style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}>
                                                    {MoneyRenderer(articleInformation.PrecioUnidad, 4)}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr style={{ borderBottom: '1px solid #ddd' }}>
                                            <td style={{ textAlign: 'left' , paddingLeft: '0px', borderCollapse: 'collapse'}}>
                                                <td>
                                                    <span
                                                        className="material-symbols-outlined"
                                                        style={{
                                                            color: '#5e5d5d',
                                                            fontSize: "1.2em",
                                                            marginRight: "5px",
                                                            position: "relative",
                                                            top: "4px"
                                                        }}
                                                    >
                                                        <SystemUpdateAltOutlinedIcon/>
                                                    </span>
                                                </td>
                                            </td>
                                            <td style={{ textAlign: 'left', paddingLeft: '10px' }}>{UnitOfMeasureTitleRenderer(articleInformation.UnidadDeItems)} por caja</td>
                                            <td className="costo-product" style={{ textAlign: 'right', paddingRight: '0px', fontFamily: `'Libre Baskerville', serif`, fontSize: '18px', color: '#c1a17d', fontWeight: '' }}>
                                                <span style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}>{articleInformation.CantidadUnidades} {UnitOfMeasureRenderer(articleInformation.UnidadDeItems)}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ textAlign: 'left' , paddingLeft: '0px', borderCollapse: 'collapse'}}>
                                                <td>
                                                    <span
                                                        className="material-symbols-outlined"
                                                        style={{
                                                            color: '#5e5d5d',
                                                            fontSize: "1.2em",
                                                            marginRight: "5px",
                                                            position: "relative",
                                                            top: "4px"
                                                        }}
                                                    >
                                                        <Inventory2OutlinedIcon/>
                                                    </span>
                                                </td>
                                            </td>
                                            <td style={{ textAlign: 'left', paddingLeft: '10px' }}>Costo Por Caja</td>
                                            <td className="costo-product" style={{ textAlign: 'right', paddingRight: '0px', fontFamily: `'Libre Baskerville', serif`, fontSize: '18px', color: '#c1a17d', fontWeight: '' }}>
                                                <span style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}>{MoneyRenderer(articleInformation.PrecioArticulo)}</span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Box className="modal-footer" sx={{ padding: '5px', textAlign: 'center', fontFamily: `'Libre Baskerville', serif` }}>
                        <Typography variant="h4" sx={{ marginBottom: '5px', color: '#ffffff', justifyContent: 'center'}} className="hidden-quantity-boxes-xs">
                            <div className="h4 title-product show" style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold'}}> Cantidad </div>
                        </Typography>
                        <Typography variant="h4" sx={{ marginBottom: '5px', color: '#ffffff', justifyContent: 'center'}} className="visible-quantity-boxes-xs">
                            <div className="h4 title-product show" style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold'}}> Cajas </div>
                        </Typography>
                        <Box
                            className="hidden-quantity-boxes-xs"
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '15px',
                                marginBottom: '20px',
                            }}
                        >
                            {[1, 2, 3, 4, 5].map((value) => (
                                <a
                                    key={value}
                                    onClick={() => addToCart(value)}
                                    className="btn btn-primary btn-add-to-cart"
                                >
                                    {value} Caja{value > 1 ? 's' : ''}
                                </a>
                            ))}
                        </Box>
                        <Box
                            className="visible-quantity-boxes-xs"
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                gap: '15px',
                                marginBottom: '20px',
                            }}
                        >

                            {[1, 2, 3, 4, 5].map((value) => (
                                <a
                                    key={value}
                                    onClick={() => addToCart(value)}
                                    className="btn btn-primary btn-add-to-cart"
                                    style={{padding: "0.8em"}}
                                >
                                    {value}
                                </a>
                            ))}
                        </Box>

                        <Box className="modal-footer" sx={{ padding: '5px', textAlign: 'center', fontFamily: `'Libre Baskerville', serif` }}>
                            <Typography
                                variant="h5"
                                sx={{ marginBottom: '5px', fontSize: '18px', color: '#ffffff' }}
                            >
                                <div className="h4 title-product show" style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}> Otra Cantidad </div>
                            </Typography>

                            <TextField
                                type="text"
                                placeholder="Ingresar Cantidad"
                                value={quantity}
                                onChange={(event) => {
                                    let inputValue = event.target.value;
                                    if (!/^\d*$/.test(inputValue)) return;
                                    const value = inputValue === "" ? "" : Math.max(0, parseInt(inputValue, 10));
                                    handleQuantityChange(value);
                                }}
                                sx={{
                                    width: '260px',
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f8f8f8',
                                        borderRadius: '5px',
                                        height: '36px',
                                        pr: 0,
                                    },
                                    '& .MuiInputBase-input': {
                                        padding: '8px 10px',
                                        fontSize: '14px',
                                    },
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end" sx={{ m: 0, p: 0 }}>
                                            <a
                                                variant="contained"
                                                onClick={() => aQuantityWasEntered && addToCart(quantity)}
                                                className="btn btn-primary btn-add-to-cart"
                                                style={{
                                                    padding: '6px 20px',
                                                    height: '34px',
                                                    minWidth: '120px',
                                                    fontSize: '14px',
                                                    borderTopLeftRadius: 0,
                                                    borderBottomLeftRadius: 0,
                                                }}
                                            >
                                                Añadir
                                            </a>
                                        </InputAdornment>
                                    ),
                                }}
                            />



                        </Box>
                    </Box>
                </Box>
            </Modal>
        </>
    );

};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
